'use client';

import { useMemo } from 'react';

import type { ToolPartRenderer } from '@/features/copilot/model';
import { AnswerPriorAuthQuestionToolCard } from '@/features/prior-auth-form/ui/AnswerPriorAuthQuestionToolCard';
import { DraftPriorAuthLetterToolCard } from '@/features/prior-auth-form/ui/DraftPriorAuthLetterToolCard';

import { UpdateTextFieldToolCard } from './tools/update-text-field';

export function useCopilotToolPartRenderers(): Readonly<Record<string, ToolPartRenderer>> {
  // ZEKKA NOTE: Where are these strings centralized? This is spaghetti.
  // There should be an enum or something corresponding to "strings that can validly appear on the left hand side
  //  of this mapping."
  return useMemo(
    (): Record<string, ToolPartRenderer> => ({
      updateTextField: (props) => <UpdateTextFieldToolCard {...props} />,
      draft_prior_auth_letter: (props) => <DraftPriorAuthLetterToolCard {...props} />,
      // The agent answers PA questions straight to DoseSpot; this bridges the
      // tool's completion to React Query so an open PA wizard refreshes right
      // away instead of waiting on its 30s poll.
      answer_prior_auth_question: (props) => <AnswerPriorAuthQuestionToolCard {...props} />,
    }),
    []
  );
}
